/**
 * Renders markdown into the site's design system.
 *
 * Used on:
 *   - ServiceDetailPage (long_description, case-study challenge/solution/outcome)
 *   - BlogPostPage (content)
 *   - TeamPage (bio)
 *   - FaqsPage (answer)
 *
 * Falls back gracefully when the input is plain text — paragraphs split on
 * blank lines just like the previous behaviour.
 */
import ReactMarkdown from "react-markdown";

const COMPONENTS = {
  p: ({ node, ...props }) => <p className="text-gray-300 leading-relaxed mb-4 last:mb-0" {...props} />,
  h2: ({ node, ...props }) => <h2 className="font-heading text-2xl md:text-3xl text-white font-semibold mt-8 mb-4" {...props} />,
  h3: ({ node, ...props }) => <h3 className="font-heading text-xl text-white font-semibold mt-6 mb-3" {...props} />,
  ul: ({ node, ...props }) => <ul className="list-disc pl-5 text-gray-300 leading-relaxed mb-4 space-y-1.5" {...props} />,
  ol: ({ node, ...props }) => <ol className="list-decimal pl-5 text-gray-300 leading-relaxed mb-4 space-y-1.5" {...props} />,
  li: ({ node, ...props }) => <li {...props} />,
  strong: ({ node, ...props }) => <strong className="text-white font-semibold" {...props} />,
  em: ({ node, ...props }) => <em className="italic text-gray-200" {...props} />,
  a: ({ node, ...props }) => <a className="text-white underline underline-offset-4 decoration-neutral-600 hover:decoration-white" target="_blank" rel="noreferrer" {...props} />,
  blockquote: ({ node, ...props }) => (
    <blockquote className="border-l-2 border-white/40 pl-4 italic text-gray-200 my-4" {...props} />
  ),
  hr: () => <hr className="my-8 border-neutral-800" />,
};

export default function Markdown({ children, className = "" }) {
  if (!children) return null;
  return (
    <div className={className}>
      <ReactMarkdown components={COMPONENTS}>{String(children)}</ReactMarkdown>
    </div>
  );
}
